module.exports = __webpack_public_path__ + "img/EgyptTechWarElephant3_ua.ca43e8e3.webp";